import React, { useEffect, useState } from "react";
import Loading from "../helpers/loading_component.js";
import PostBookBuffer from "./postBookBuffer.js";
import { secretKey } from "../.././data";
import PostBookAdd from "./postBookAdd.js";
import PostBookSend2 from "./postBookSend2.js";

const PostBook = (props) => {
  const [loading, setLoading] = useState(true);
  const [showBuffer, setShowBuffer] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showSend, setShowSend] = useState(false);

  useEffect(() => {
    setLoading(false);
  });

  return (
    <>
      <div className="mainContainerPayments">
        <div
          style={{ width: "100%", marginBottom: "1vh" }}
          className="closeBox"
        >
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="paymentMenuContainer">
          <button
            className="paymentMenuButton"
            style={{
              backgroundColor: "green",
              color: "white",
              border: "white",
            }}
            onClick={() => {
              setShowBuffer(true);
              setShowSend(false);
              setShowAdd(false);
            }}
          >
            BIEŻĄCA KSIĄŻKA NADAWCZA
          </button>
          <button
            className="paymentMenuButton"
            style={{
              backgroundColor: "orange",
              color: "white",
              border: "white",
            }}
            onClick={() => {
              setShowSend(true);
              setShowBuffer(false);
              setShowAdd(false);
            }}
          >
            ARCHIWALNE KSIĄŻKI NADAWCZE
          </button>
          <button
            className="paymentMenuButton"
            style={{
              backgroundColor: "blue",
              color: "white",
              border: "white",
            }}
            onClick={() => {
              setShowAdd(true);
              setShowSend(false);
              setShowBuffer(false);
            }}
          >
            DODAJ PRZESYŁKĘ
          </button>
        </div>
        {loading ? (
          <>
            <Loading />
          </>
        ) : (
          <>
            {showBuffer || (!showBuffer && !showAdd && !showSend) ? (
              <>
                <PostBookBuffer
                  close={() => setShowBuffer(false)}
                  user={props.user}
                  checkPermissions={props.checkPermissions}
                  logClientAction={props.logClientAction}
                />
              </>
            ) : (
              ""
            )}
            {showAdd ? (
              <>
                <PostBookAdd
                  close={() => setShowAdd(false)}
                  user={props.user}
                  checkPermissions={props.checkPermissions}
                  logClientAction={props.logClientAction}
                />
              </>
            ) : (
              ""
            )}

            {showSend ? (
              <>
                <PostBookSend2
                  close={() => setShowSend(false)}
                  user={props.user}
                  checkPermissions={props.checkPermissions}
                  logClientAction={props.logClientAction}
                />
              </>
            ) : (
              ""
            )}
          </>
        )}
      </div>
    </>
  );
};

export default PostBook;
